/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import api from '../../services/api';

import Header from '../../components/Header';
import Content from '../../components/Content';

import CurrentPlan from './components/CurrentPlan';
import LoadModal from '../../components/LoadModal';
import Footer from '../../components/Footer';

import iconBack from '../../assets/plans/icon-back.png';
import gift from '../../assets/icons/gift.png';

import {
  Container,
  Row,
  Description,
  GradientBackground,
  GiftForFriend,
} from './styles';

const Plans = () => {
  const history = useHistory();
  const [userPlan, setUserPlan] = useState({
    plan_type: {
      name: '',
      price: '',
    },
  });
  const [showLoadModal, setShowLoadModal] = useState(false);

  const [message, setMessage] = useState('');

  const checkIfUserHasAnActivePlan = async () => {
    setShowLoadModal(true);

    try {
      const response = await api.get(`/users/plans`);
      const userPlan = response.data;
      if (userPlan.status === 'pending') {
        history.push('/escolha-um-plano');
      }
      setUserPlan(response.data);
    } catch (error) {
      history.push('/escolha-um-plano');
    } finally {
      setShowLoadModal(false);
    }
  };

  useEffect(() => {
    checkIfUserHasAnActivePlan();
    window.scrollTo(0, 0);
  }, []);

  const handleGiftForFriend = async () => {
    setShowLoadModal(true);

    try {
      await api.post('/gift-code');

      console.log('E-mail enviado com sucesso!');
      setMessage('E-mail enviado com sucesso!');
    } catch (error) {
      console.log(error.response.data.message);
      setMessage(error.response.data.message);
    } finally {
      setShowLoadModal(false);
    }
  }

  return (
    <Container>
      <Header />

      <Content>
        <Row>
          <img
            onClick={() => history.goBack()}
            src={iconBack}
            alt="Ícone de voltar para a página anterior"
          />
        </Row>

        <Row>
          <Description>
            <h1>Planos</h1>

            <p>
              Aqui você verá as informações do seu Plano, poderá altera-lo caso
              queira.
            </p>

            <GiftForFriend onClick={handleGiftForFriend}>
              <img src={gift} alt="Ícone de presente" />

              <div>
                <span>Receba os acessos pelo e-mail</span>
              </div>
            </GiftForFriend>

            {message && <p style={{color: 'red', marginTop: '30px'}}>{message}</p>}
          </Description>
          <div>
            <CurrentPlan plan={userPlan} />
          </div>
        </Row>
      </Content>

      <Footer />

      <GradientBackground />

      <LoadModal show={showLoadModal} />
    </Container>
  );
};

export default Plans;
